<template>
    <div class="c-confirm-container">
        <c-confirm-message v-show="confirm.open"></c-confirm-message>
    </div>
</template>

<script>
import CConfirmMessage from '@components/confirm/Message';
import { mapState } from 'vuex';

export default {
    components: { CConfirmMessage },
    computed: {
        ...mapState ({
            confirm: state => state.confirm
        })
    }
}
</script>
